// Fields draw their border as an outline, so keep it unoffset or the global focus style doubles it.
export const fieldOutline = (focused: string) => `
  outline: 0.5px solid var(--border-alpha);
  transition: box-shadow var(--motion-fast) var(--ease-out);
  ${focused} {
    outline: 0.5px solid var(--control-bg);
    box-shadow: 0 0 0 3px var(--border-alpha);
  }
`;
